import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "22",
  viewBox: "0 0 20 22",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "currentColor",
      "fill-rule": "nonzero"
    }, [
      _createElementVNode("path", { d: "M10 0c3.184 0 5.774 2.511 5.89 5.647l.004.22h-1.2a4.694 4.694 0 0 0-9.383-.215l-.005.215h-1.2C4.106 2.629 6.742 0 10 0Z" }),
      _createElementVNode("path", { d: "M20 5.573V22H0V5.573h20Zm-1.2 1.173H1.2v14.08h17.6V6.746Z" })
    ], -1)
  ])))
}
export default { render: render }